import Vue from 'vue'
import FloatingVue from 'floating-vue'
import detector from "@/utils/mobileDetector";

Vue.use(FloatingVue)
FloatingVue.enabled = !detector.mobile();
